<script>

    import Moment from 'moment'

    import GraphicsService from '../$services/graphics.service'
    import NumeralMethods from '../$methods/numeral.methods'

    export let dateStart = null
    export let dateEnd = null

    let steps = []

    $: periodLabel = dateStart && dateEnd
        ? `${Moment(dateStart).locale('es').format('D MMM YYYY')} - ${Moment(dateEnd).locale('es').format('D MMM YYYY')}`
        : ''

    $: maxCount = Math.max(0, ...steps.map((s) => s.count || 0))

    $: load(dateStart, dateEnd)

    async function load(start, end) {
        if (!start || !end) return

        const res = await GraphicsService.getEventsFunnel({
            dateStart: start.toISOString(),
            dateEnd: end.toISOString(),
        })

        const data = res?.data ?? res
        steps = data?.steps ?? []
    }

    function barWidth(count) {
        if (!maxCount) return 0
        return (count / maxCount) * 100
    }

</script>

<style>
    .card {
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
        padding: 1.35rem 1.5rem;
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .header {
        margin-bottom: 1.25rem;
    }

    .title-row {
        display: flex;
        align-items: center;
        gap: 0.4rem;
    }

    .title {
        font-size: 1.05rem;
        font-weight: 700;
        color: #1a1a1a;
        margin: 0;
        line-height: 1.2;
    }

    .info {
        color: #b0b0b0;
        font-size: 0.85rem;
        line-height: 1;
    }

    .period {
        font-size: 0.85rem;
        color: #9e9e9e;
        margin: 0.25rem 0 0;
        text-transform: capitalize;
    }

    .rows {
        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
    }

    .row {
        display: grid;
        grid-template-columns: 1.4rem 7.5rem 3.5rem 1fr;
        align-items: center;
        gap: 0.75rem;
        min-height: 2.75rem;
    }

    .marker {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        color: #1a1a1a;
        font-size: 0.85rem;
    }

    .marker::before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 50%;
        width: 1px;
        background: #e5e7eb;
        transform: translateX(-50%);
    }

    .row:first-child .marker::before {
        top: 50%;
    }

    .row:last-child .marker::before {
        bottom: 50%;
    }

    .marker i {
        position: relative;
        z-index: 1;
        background: #fff;
        padding: 0.15rem 0;
    }

    .label {
        font-size: 0.9rem;
        color: #1a1a1a;
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .count {
        font-size: 0.9rem;
        font-weight: 700;
        color: #1a1a1a;
        text-align: right;
        font-variant-numeric: tabular-nums;
    }

    .bar-track {
        height: 1.65rem;
        background: #f0f1f3;
        border-radius: 6px;
        overflow: hidden;
        display: flex;
        align-items: stretch;
        justify-content: center;
    }

    .bar-fill {
        height: 100%;
        background: #098E37;
        border-radius: 6px;
        min-width: 0;
    }
</style>

<div class="card">
    <div class="header">
        <div class="title-row">
            <h3 class="title">Embudo de conversión</h3>
            <i class="fas fa-info-circle info" title="Actividad registrada por etapa"></i>
        </div>
        {#if periodLabel}
            <p class="period">{ periodLabel }</p>
        {/if}
    </div>

    <ul class="rows">
        {#each steps as step}
            <li class="row">
                <div class="marker">
                    <i class="fas fa-map-marker-alt"></i>
                </div>
                <span class="label">{ step.label }</span>
                <span class="count">{ NumeralMethods.number(step.count) }</span>
                <div class="bar-track">
                    <div class="bar-fill" style="width: { barWidth(step.count) }%"></div>
                </div>
            </li>
        {/each}
    </ul>
</div>
